import HttpConnectorService from "./HttpConnectorService";
import { API_URL } from "appConfig";
import TwitchHelixApiService from "./TwitchHelixApiService";

export const http = new HttpConnectorService({
  prefixUrl: API_URL,
});

export const twitchHelix = new TwitchHelixApiService(
  new HttpConnectorService({
    prefixUrl: "https://api.twitch.tv/helix/",
  })
);
